import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { DocumentModel } from "@tecumseh/Services/DocumentsSearchService";

import { Draft } from "immer";

export type CustomDocumentSearchResultType = {
    isLoading: boolean;
    documents: DocumentModel[];
    requestCompleted: boolean;
    query: string;
};
const initialState: CustomDocumentSearchResultType = {
    isLoading: false,
    documents: [],
    requestCompleted: false,
    query: "",
};

const reducer = {
    "Custom/SearchResults/StartFetchingDocuments": (draft: Draft<CustomDocumentSearchResultType>) => {
        draft.isLoading = true;
        draft.requestCompleted = false;
    },
    "Custom/SearchResults/SetDocuments": (
        draft: Draft<CustomDocumentSearchResultType>,
        action: { documents: any[] },
    ) => {
        draft.documents = action.documents;
        draft.isLoading = false;
        draft.requestCompleted = true;
    },
    "Custom/SearchResults/UpdateDocumentsQuery": (
        draft: Draft<CustomDocumentSearchResultType>,
        action: { query: string },
    ) => {
        draft.query = action.query;
    },
};
export default createTypedReducerWithImmer(initialState, reducer);
